<template>
    <v-card 
        max-width="500"
        light 
        class="card-container"
    >
        <img src="static/img/Cross.svg" 
            style="float: right; height: 14px;"
            class="cross-close" 
            @click="close"
        >
        <img src="static/img/deploiement-impossible@2x.png" class="img-deploiement-impossible">
        <h3 class="instance_title_free_version">{{$t('instance.instance_list.index.title_modal_free_version')}}</h3>
        
        <v-card-text v-html="$t('instance.instance_list.instance_details.modale_free_version_text', {openSourceDocumentation: linkOpenSource, plan: linkPlan})"
            class="instance_text_free_version"
            target="_blank"
        >
        </v-card-text>
        
        <v-card-actions 
            class="free_version_button">
            <v-btn 
            color=" darken-1" 
            text
            @click="close"
            class="free_button_text"
            >
                {{$t('instance.instance_list.instance_item.button_understand_close')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
    data (){
        return {
            freeVersionDialog: false,
        };
    },
    methods: {
        open(){
            this.freeVersionDialog = true;
        },
        close() {
            this.$emit('close-card');
        },
    },
    computed: {
        linkOpenSource(){
            return window.config.open_source_documentation;
        },
        linkPlan(){
            return window.config.concrete_site;
        },

    }
}
</script>

<style type="text/css" scoped>

.card-container{
    text-align: center; 
    padding: 24px; top: 50%;
    left: 50%;
    -webkit-transform: translate(-65%, -86%);
}

.cross-close:hover{
    cursor: pointer;
}

.img-deploiement-impossible{
    max-height: 165px;
    margin-top: 32px;
}

.instance_title_free_version{
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    font-weight: 400;
    color: #757575;
    padding-top: 20px;
}

.instance_text_free_version{
    font-family: Open Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 29px;
    text-align: center;
    color: #212121;
    padding: 14px 0 0 0;
}

.free_version_button{
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 2px;
    margin-top: 24px;
}

.free_button_text{
    background-color: #F5F5F5;
    color: #212121;
    text-transform: none;
}

    
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceList/modal-free-version.vue